import React from 'react';
import { Headphones, Truck, Shield, Star, Flame } from 'lucide-react';
import { announcements } from '../mock/mock';

const iconMap = { headphones: Headphones, truck: Truck, shield: Shield, star: Star, flame: Flame };

const AnnouncementBar = () => {
  const items = [...announcements, ...announcements, ...announcements, ...announcements];
  return (
    <div className="bg-gradient-to-r from-[#ff8247] via-[#ff4d1a] to-[#ff2d6f] py-2.5 overflow-hidden">
      <div className="marquee-track flex items-center gap-10">
        {items.map((item, i) => {
          const Icon = iconMap[item.icon] || Star;
          return (
            <div key={i} className="flex items-center gap-2 whitespace-nowrap">
              <Icon className="w-4 h-4 text-[#0a0a0f]" />
              <span className="text-[#0a0a0f] text-xs font-bold uppercase tracking-wider">{item.text}</span>
              <span className="text-[#0a0a0f]/40 mx-4">•</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AnnouncementBar;
